import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './outline-admin-links.global.pcss?inline';

/**
 * The Outline Admin Links component
 * @element outline-admin-links
 * @slot - The default, and only slot for this element.
 */
@customElement('outline-admin-links')
export class OutlineAdminLinks extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  /**
   * Handles admin links open/closed for mobile screen sizes.
   */
  @property({ type: Boolean, reflect: true })
  open = false;

  /**
   * A reference to the button element that triggers the opening and closing of the admin links.
   */
  private trigger: HTMLButtonElement | null = null;

  _handleTriggerClick = () => {
    this.open = !this.open;
  };

  firstUpdated(changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(changedProperties);
    this.trigger = this.querySelector('.tabs__trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', this._handleTriggerClick);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.trigger) {
      this.trigger.removeEventListener('click', this._handleTriggerClick);
    }
  }

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-admin-links': OutlineAdminLinks;
  }
}
